import { PERSPECTIVES } from "@/data/perspectives";

export function useArticles() {
  return { articles: PERSPECTIVES, loading: false };
}
